import { getData, postData, putData, deleteData } from '../FetchApiServices';

const base = (id) => `t2t/vendors/${id}`;

// ─── Documents ────────────────────────────────────────────────────────────────
export const listVendorDocs        = (vendorId)        => getData(`${base(vendorId)}/documents`);
export const deleteVendorDoc       = (vendorId, docId) => deleteData(`${base(vendorId)}/documents/${docId}`);
export const getDocDownloadUrl     = (vendorId, docId) => getData(`${base(vendorId)}/documents/${docId}/download`);
export const registerVendorDoc     = (vendorId, body)  => postData(`${base(vendorId)}/documents`, body);
export const presignVendorDoc      = (vendorId, body)  => postData(`${base(vendorId)}/documents/presign`, body);

// ─── Addresses ────────────────────────────────────────────────────────────────
export const listVendorAddresses   = (vendorId)           => getData(`${base(vendorId)}/addresses`);
export const createVendorAddress   = (vendorId, body)     => postData(`${base(vendorId)}/addresses`, body);
export const updateVendorAddress   = (vendorId, id, body) => putData(`${base(vendorId)}/addresses/${id}`, body);
export const deleteVendorAddress   = (vendorId, id)       => deleteData(`${base(vendorId)}/addresses/${id}`);

// ─── Bank Accounts ────────────────────────────────────────────────────────────
export const listVendorBankAccounts  = (vendorId)           => getData(`${base(vendorId)}/bank-accounts`);
export const createVendorBankAccount = (vendorId, body)     => postData(`${base(vendorId)}/bank-accounts`, body);
export const updateVendorBankAccount = (vendorId, id, body) => putData(`${base(vendorId)}/bank-accounts/${id}`, body);
export const deleteVendorBankAccount = (vendorId, id)       => deleteData(`${base(vendorId)}/bank-accounts/${id}`);

// ─── Audit / History ─────────────────────────────────────────────────────────
export const listVendorHistory       = (vendorId)  => getData(`${base(vendorId)}/history`);
